import React, { Fragment, useState, useEffect } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import Moment from "react-moment";

//** Import Image */
import profile01 from "../../../../images/profile/1.jpg";
import profile05 from "../../../../images/profile/5.jpg";
import profile06 from "../../../../images/profile/6.jpg";
import profile07 from "../../../../images/profile/7.jpg";
import profile08 from "../../../../images/profile/8.jpg";
import profile09 from "../../../../images/profile/9.jpg";
import profile from "../../../../images/profile/profile.png";
import { Row, Card, Col, Button, Nav, Table, Pagination } from "react-bootstrap";

import Lightgallery from './Lightgallery';
import { Dropdown } from "react-bootstrap";
import Cookies from "universal-cookie";
import { getUserDataApi } from '../../../../apis/AuthenticationAPI';
import { getEvents } from '../../../../apis/EventAPI';
import { getCertificateTemplates } from '../../../../apis/TemplateAPI';
import { getCreditsData, transactCredit } from "../../../../apis/Credits";
import { toast } from 'react-toastify';


const InstituteProfile = () => {
    toast.configure();
    const { clientId } = useParams();
    const [activeToggle, setActiveToggle] = useState("posts");
    const cookies = new Cookies();
    const token = cookies.get("token")
    const history = useHistory();
    const [eventData, setEventData] = useState()
    const [templateData, setTemplateData] = useState()
    const [userData, setUserData] = useState()
    const [followersCount, setFollowersCount] = useState()
    const [followingCount, setFollowingCount] = useState()
    const [posts, setPosts] = useState()
    const [userId, setUserId] = useState()
    const [profileType, setProfileType] = useState()
    const [creditsData, setCreditsData] = useState()
    const [creditsBalance, setCreditsBalance] = useState()
    const [credAmount,setCredAmount] = useState()
    
    useEffect(() => {
        if (token === null || token === undefined) {
            history.push("/page-login");
        }
        fetchEventData()

    }, [])

    const addAmount = (e) =>{
        e.preventDefault();
        transactCredit(token,clientId,"Add",credAmount)
        .then(response=>{
            if(response.code === 200)
            {
                toast.success("Credit Added", {
                    position: 'top-left',
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: false
                  })
                  getCreditsData(token, clientId)
            .then(resp => {

                if (resp.code === 200) {
                    setCreditsData(resp.data.data)
                    setCreditsBalance(resp.data.balance)
                }
            }).catch(error=>{
                console.log("Error is ",error)
            })
            }
            
            
            
        })
        .catch(error =>{
            toast.error("Error in transaction : "+error.response.data.message, {
                position: 'top-left',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: false
              })
        })
    }
    const subtractAmount = (e) =>{
        e.preventDefault();
        transactCredit(token,clientId,"Subtract",credAmount)
        .then(response=>{
            if(response.code === 200)
            {
                toast.success("Credit Subtracted", {
                    position: 'top-left',
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: false
                  })
            getCreditsData(token, clientId)
            .then(resp => {

                if (resp.code === 200) {
                    setCreditsData(resp.data.data)
                    setCreditsBalance(resp.data.balance)
                }
            }).catch(error=>{
                console.log("Error is ",error)
            })
            
            }
            
        })
        .catch(error =>{
            toast.error("Error in transaction: "+error.response.data.message, {
                position: 'top-left',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: false
              })
        })

    }

    const fetchEventData = () => {

        getUserDataApi(token, clientId)
            .then(response => {
                if (response.status === 200) {
                    setUserData(response.data[0]?.profile_data)
                    setFollowersCount(response.data[0]?.follower_count)
                    setFollowingCount(response.data[0]?.following_count)
                    setPosts(response.data[0]?.posts)
                    setProfileType(response?.data[0]?.profile_type)
                    setUserId(response.data[0]?.profile_data?.id)
                }
            })
            .catch(error => {
                console.log(error)
            })
        getEvents(token, clientId)
            .then(response => {
                if (response.status == 200) {
                    setEventData(response.data);
                }
            })
            .catch(error => { console.log("error is " + error) })
        getCertificateTemplates(token, clientId)
            .then(response => {
                if (response.status == 200) {
                    setTemplateData(response.data);
                }
            })
            .catch(error => { console.log("error is " + error) })
        getCreditsData(token, clientId)
            .then(response => {

                if (response.code == 200) {
                    setCreditsData(response.data.data)
                    setCreditsBalance(response.data.balance)
                }
            }).catch(error=>{
                console.log("Error is ",error)
            })
    }
    return (
        <Fragment>
            <div className="page-titles">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to={"#"}>App</Link></li>
                    <li className="breadcrumb-item active"><Link to={"#"}>Profile</Link></li>
                </ol>
            </div>

            <div className="row">
                <div className="col-lg-12">
                    <div className="profile card card-body px-3 pt-3 pb-0">
                        <div className="profile-head">
                            <div className="photo-content">
                                <div className="cover-photo" style={{ backgroundImage: `url(${userData?.banner})` }}></div>
                            </div>
                            <div className="profile-info">
                                <div className="profile-photo">
                                    <img src={userData?.profile_photo} className="img-fluid rounded-circle" alt="profile" />
                                </div>
                                <div className="profile-details">
                                    <div className="profile-name px-3 pt-2">
                                        <h4 className="text-primary mb-0">
                                            {userData?.fname + " " + userData?.lname}
                                        </h4>
                                        {/* <p>{profileType}</p> */}
                                    </div>
                                    <div className="profile-email px-2 pt-2">
                                        <h4 className="text-muted mb-0">
                                            {userData?.email}
                                        </h4>
                                        <p>Email</p>
                                    </div>
                                    <div className="col">
                                        <h3 className="m-b-0">{followersCount}</h3>
                                        <span>Followers</span>
                                    </div>
                                    <div className="col">
                                        <h3 className="m-b-0">{followingCount}</h3>
                                        <span>Following</span>
                                    </div>
                                    <div className="col">
                                        <h3 className="m-b-0">{posts?.length}</h3>
                                        <span>Posts</span>
                                    </div>
                                    {/* <Dropdown className="dropdown ml-auto">
								<Dropdown.Toggle
									variant="primary"
									className="btn btn-primary light sharp icon-false"
									data-toggle="dropdown"
									aria-expanded="true"
								>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    //    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    width="18px"
                                    height="18px"
                                    viewBox="0 0 24 24"
                                    version="1.1"
                                >
                                    <g
                                       stroke="none"
                                       strokeWidth="1"
                                       fill="none"
                                       fillRule="evenodd"
                                    >
                                       <rect x="0" y="0" width="24" height="24"></rect>
                                       <circle  fill="#000000"  cx="5"  cy="12"  r="2" ></circle>
                                       <circle fill="#000000" cx="12" cy="12"  r="2" ></circle>
                                       <circle fill="#000000" cx="19"  cy="12" r="2"  ></circle>
									</g>
                                </svg>
								</Dropdown.Toggle>
									<Dropdown.Menu className="dropdown-menu dropdown-menu-right">
									<Dropdown.Item className="dropdown-item">
										<i className="fa fa-user-circle text-primary mr-2" />
										View profile
									</Dropdown.Item>
									<Dropdown.Item className="dropdown-item">
										<i className="fa fa-users text-primary mr-2" />
										Add to close friends
									</Dropdown.Item>
									<Dropdown.Item className="dropdown-item">
										<i className="fa fa-plus text-primary mr-2" />
										Add to group
									</Dropdown.Item>
									<Dropdown.Item className="dropdown-item">
										<i className="fa fa-ban text-primary mr-2" />
										Block
									</Dropdown.Item>
								</Dropdown.Menu>
                            </Dropdown> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                {/* <div className="col-xl-4">
               <div className="card">
                  <div className="card-body">
                     <div className="profile-statistics mb-5">
                        <div className="text-center">
							<div className="row">
								<div className="col">
									<h3 className="m-b-0">150</h3>
									<span>Follower</span>
								</div>
								<div className="col">
									<h3 className="m-b-0">140</h3>
									<span>Place Stay</span>
								</div>
								<div className="col">
									<h3 className="m-b-0">45</h3>
									<span>Reviews</span>
								</div>
							</div>
							<div className="mt-4">
								<Link
									to="/app-profile"
									className="btn btn-primary mb-1 mr-1"
								>
									Follow
								</Link>
								<Link
									to="/app-profile"
									className="btn btn-primary mb-1"
								>
									Send Message
								</Link>
							</div>
                        </div>
                     </div>
                     <div className="profile-blog mb-5">
                        <h5 className="text-primary d-inline">Today Highlights</h5><Link to={"#"} className="pull-right f-s-16">More</Link>
                        <img
                           src={profile01}
                           alt="profile"
                           className="img-fluid mt-4 mb-4 w-100"
                        />
                        <h4><Link to="/post-details" className="text-black"> Darwin Creative Agency Theme</Link></h4>
                        <p className="mb-0">
                           A small river named Duden flows by their place and
                           supplies it with the necessary regelialia. It is a
                           paradisematic country, in which roasted parts of
                           sentences fly into your mouth.
                        </p>
                     </div>
						light gallery  box
						<div>
							<Lightgallery />
						</div>
						light gallery  box End
                    <div className="profile-news">
                        <h5 className="text-primary d-inline">Our Latest News</h5>
                        <div className="media pt-3 pb-3">
							<img src={profile05} alt="" className="mr-3 rounded" style={{width: "75px"}}/>
                           <div className="media-body">
								<h5 className="m-b-5"><Link to="/post-details" className="text-black">Collection of textile samples</Link></h5>
								<p className="mb-0">I shared this on my fb wall a few months back, and I thought. </p>
                           </div>
                        </div>
                        <div className="media pt-3 pb-3">
                           <img src={profile06} alt="" className="mr-3 rounded" style={{width: "75px"}}/>
                           <div className="media-body">
								<h5 className="m-b-5"><Link className="text-black" to="/post-details">Collection of textile samples</Link></h5>
								<p className="mb-0">I shared this on my fb wall a few months back,and I thought.</p>
                           </div>
                        </div>
                        <div className="media pt-3 pb-3">
                           <img src={profile07} alt="" className="mr-3 rounded" style={{width: "75px"}} />
                           <div className="media-body">
								<h5 className="m-b-5"><Link className="text-black" to="/post-details">Collection of textile samples</Link></h5>
								<p className="mb-0">I shared this on my fb wall a few months back, and I thought.</p>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div> */}
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="profile-tab">
                                <div className="custom-tab-1">
                                    <ul className="nav nav-tabs">
                                        <li
                                            className="nav-item"
                                            onClick={() => setActiveToggle("posts")}
                                        >
                                            <Link
                                                to="#my-posts"
                                                data-toggle="tab"
                                                className={`nav-link ${activeToggle === "posts"
                                                    ? "active show"
                                                    : ""
                                                    }`}
                                            >
                                                Posts
                                            </Link>
                                        </li>
                                        <li
                                            className="nav-item"
                                            onClick={() => setActiveToggle("aboutMe")}
                                        >
                                            <Link
                                                to="#about-me"
                                                data-toggle="tab"
                                                className={`nav-link ${activeToggle === "aboutMe"
                                                    ? "active show"
                                                    : ""
                                                    }`}
                                            >
                                                About Me
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link
                                                to="#profile-settings"
                                                data-toggle="tab"
                                                onClick={() => setActiveToggle("setting")}
                                                className={`nav-link ${activeToggle === "setting"
                                                    ? "active show"
                                                    : ""
                                                    }`}
                                            >
                                                Setting
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link
                                                to="#profile-events"
                                                data-toggle="tab"
                                                onClick={() => setActiveToggle("events")}
                                                className={`nav-link ${activeToggle === "events"
                                                    ? "active show"
                                                    : ""
                                                    }`}
                                            >
                                                Events
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link
                                                to="#profile-templates"
                                                data-toggle="tab"
                                                onClick={() => setActiveToggle("templates")}
                                                className={`nav-link ${activeToggle === "templates"
                                                    ? "active show"
                                                    : ""
                                                    }`}
                                            >
                                                Templates
                                            </Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link
                                                to="#profile-credits"
                                                data-toggle="tab"
                                                onClick={() => setActiveToggle("credits")}
                                                className={`nav-link ${activeToggle === "credits"
                                                    ? "active show"
                                                    : ""
                                                    }`}
                                            >
                                                Credits
                                            </Link>
                                        </li>
                                    </ul>
                                    <div className="tab-content">
                                        <div
                                            id="my-posts"
                                            className={`tab-pane fade ${activeToggle === "posts"
                                                ? "active show"
                                                : ""
                                                }`}
                                        >
                                            <div className="my-post-content pt-3">
                                                {/* <div className="post-input">
                                       <textarea
                                          name="textarea"
                                          id="textarea"
                                          cols="30"
                                          rows="5"
                                          className="form-control bg-transparent"
                                          defaultValue="Please type what you want...."
                                       />
                                       <Link
                                          to="/app-profile"
                                          className="btn btn-primary light mr-1 px-3"
                                       >
                                          <i className="fa fa-link" />
                                       </Link>
                                       <Link
                                          to="/app-profile"
                                          className="btn btn-primary light mr-1 px-3"
                                       >
                                          <i className="fa fa-camera" />
                                       </Link>
                                       <Link
                                          to="/app-profile"
                                          className="btn btn-primary"
                                       >
                                          Post
                                       </Link>
                                    </div> */}
                                                <div className="profile-uoloaded-post border-bottom-1 pb-5 ">
                                                    <img
                                                        src={profile08}
                                                        alt=""
                                                        className="img-fluid w-100"
                                                    />
                                                    <Link
                                                        className="post-title"
                                                        to="/post-details"
                                                    >
                                                        <h4>
                                                            Collection of textile samples lay
                                                            spread
                                                        </h4>
                                                    </Link>
                                                    <p>
                                                        A wonderful serenity has take
                                                        possession of my entire soul like
                                                        these sweet morning of spare which
                                                        enjoy whole heart.A wonderful serenity
                                                        has take possession of my entire soul
                                                        like these sweet morning of spare
                                                        which enjoy whole heart.
                                                    </p>
                                                    <button className="btn btn-primary mr-2">
                                                        <span className="mr-2">
                                                            <i className="fa fa-heart" />
                                                        </span>
                                                        Like
                                                    </button>
                                                    <Link to={"/post-details"}>
                                                        <button className="btn btn-secondary">
                                                            <span className="mr-2">
                                                                <i className="fa fa-reply" />
                                                            </span>
                                                            Reply
                                                        </button>
                                                    </Link>

                                                </div>
                                                <div className="profile-uoloaded-post border-bottom-1 pb-5">
                                                    <img
                                                        src={profile09}
                                                        alt=""
                                                        className="img-fluid"
                                                    />
                                                    <Link
                                                        className="post-title"
                                                        to="/post-details"
                                                    >
                                                        <h4>
                                                            Collection of textile samples lay
                                                            spread
                                                        </h4>
                                                    </Link>
                                                    <p>
                                                        A wonderful serenity has take
                                                        possession of my entire soul like
                                                        these sweet morning of spare which
                                                        enjoy whole heart.A wonderful serenity
                                                        has take possession of my entire soul
                                                        like these sweet morning of spare
                                                        which enjoy whole heart.
                                                    </p>
                                                    <button className="btn btn-primary mr-2">
                                                        <span className="mr-2">
                                                            <i className="fa fa-heart" />
                                                        </span>
                                                        Like
                                                    </button>
                                                    <Link to={"/post-details"}>
                                                        <button className="btn btn-secondary">
                                                            <span className="mr-2">
                                                                <i className="fa fa-reply" />
                                                            </span>
                                                            Reply
                                                        </button>
                                                    </Link>
                                                </div>
                                                <div className="profile-uoloaded-post pb-3">
                                                    <img
                                                        src={profile08}
                                                        alt=""
                                                        className="img-fluid"
                                                    />
                                                    <Link
                                                        className="post-title"
                                                        to="/post-details"
                                                    >
                                                        <h4>
                                                            Collection of textile samples lay
                                                            spread
                                                        </h4>
                                                    </Link>
                                                    <p>
                                                        A wonderful serenity has take
                                                        possession of my entire soul like
                                                        these sweet morning of spare which
                                                        enjoy whole heart.A wonderful serenity
                                                        has take possession of my entire soul
                                                        like these sweet morning of spare
                                                        which enjoy whole heart.
                                                    </p>
                                                    <button className="btn btn-primary mr-2">
                                                        <span className="mr-2">
                                                            <i className="fa fa-heart" />
                                                        </span>
                                                        Like
                                                    </button>
                                                    <Link to={"/post-details"}>
                                                        <button className="btn btn-secondary">
                                                            <span className="mr-2">
                                                                <i className="fa fa-reply" />
                                                            </span>
                                                            Reply
                                                        </button>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            id="about-me"
                                            className={`tab-pane fade ${activeToggle === "aboutMe"
                                                ? "active show"
                                                : ""
                                                }`}
                                        >
                                            <div className="profile-about-me">
                                                <div className="pt-4 border-bottom-1 pb-3">
                                                    <h4 className="text-primary">
                                                        Bio
                                                    </h4>
                                                    <p className="mb-2">
                                                        {userData?.bio}
                                                    </p>
                                                </div>
                                            </div>
                                            {/* <div className="profile-skills mb-5">
                                    <h4 className="text-primary mb-2">
                                       Skills
                                    </h4>
                                    <Link
                                       to="/app-profile"
                                       className="btn btn-primary light btn-xs mb-1 mr-1"
                                    >
                                       Admin
                                    </Link>
                                    <Link
                                       to="/app-profile"
                                       className="btn btn-primary light btn-xs mb-1 mr-1"
                                    >
                                       Dashboard
                                    </Link>
                                    <Link
                                       to="/app-profile"
                                       className="btn btn-primary light btn-xs mb-1 mr-1"
                                    >
                                       Photoshop
                                    </Link>
                                    <Link
                                       to="/app-profile"
                                       className="btn btn-primary light btn-xs mb-1 mr-1"
                                    >
                                       Bootstrap
                                    </Link>
                                    <Link
                                       to="/app-profile"
                                       className="btn btn-primary light btn-xs mb-1 mr-1"
                                    >
                                       Responsive
                                    </Link>
                                    <Link
                                       to="/app-profile"
                                       className="btn btn-primary light btn-xs mb-1 mr-1"
                                    >
                                       Crypto
                                    </Link>
                                 </div> */}
                                            {/* <div className="profile-lang  mb-5">
                                    <h4 className="text-primary mb-2">
                                       Language
                                    </h4>
                                    <Link
                                       to="/app-profile"
                                       className="text-muted pr-3 f-s-16"
                                    >
                                       <i className="flag-icon flag-icon-us" />
                                       English
                                    </Link>
                                    <Link
                                       to="/app-profile"
                                       className="text-muted pr-3 f-s-16"
                                    >
                                       <i className="flag-icon flag-icon-fr" />
                                       French
                                    </Link>
                                    <Link
                                       to="/app-profile"
                                       className="text-muted pr-3 f-s-16"
                                    >
                                       <i className="flag-icon flag-icon-bd" />
                                       Bangla
                                    </Link>
                                 </div> */}
                                            <div className="profile-personal-info">
                                                <h4 className="text-primary mb-4">
                                                    Personal Information
                                                </h4>
                                                <div className="row mb-sm-2 mb-3">
                                                    <div className="col-sm-3">
                                                        <h5 className="f-w-500">
                                                            Name
                                                            <span className="pull-right d-none d-sm-block">
                                                                :
                                                            </span>
                                                        </h5>
                                                    </div>
                                                    <div className="col-sm-9">
                                                        <span>{userData?.fname + " " + userData?.lname}</span>
                                                    </div>
                                                </div>
                                                <div className="row mb-sm-2 mb-3">
                                                    <div className="col-sm-3">
                                                        <h5 className="f-w-500">
                                                            Email
                                                            <span className="pull-right d-none d-sm-block">
                                                                :
                                                            </span>
                                                        </h5>
                                                    </div>
                                                    <div className="col-sm-9">
                                                        <span>{userData?.email}</span>
                                                    </div>
                                                </div>
                                                <div className="row mb-sm-2 mb-3">
                                                    <div className="col-sm-3">
                                                        <h5 className="f-w-500">
                                                            Date of Birth
                                                            <span className="pull-right d-none d-sm-block">
                                                                :
                                                            </span>
                                                        </h5>
                                                    </div>
                                                    <div className="col-sm-9">
                                                        <span>{userData?.dob}</span>
                                                    </div>
                                                </div>
                                                {/* <div className="row mb-2">
                                       <div className="col-sm-3">
                                          <h5 className="f-w-500">
                                             Age
                                             <span className="pull-right d-none d-sm-block">
                                                :
                                             </span>
                                          </h5>
                                       </div>
                                       <div className="col-sm-9">
                                          <span>27</span>
                                       </div>
                                    </div>
                                    <div className="row mb-sm-2 mb-3">
                                       <div className="col-sm-3">
                                          <h5 className="f-w-500">
                                             Location
                                             <span className="pull-right d-none d-sm-block">
                                                :
                                             </span>
                                          </h5>
                                       </div>
                                       <div className="col-sm-9">
                                          <span>
                                             Rosemont Avenue Melbourne, Florida
                                          </span>
                                       </div>
                                    </div>
                                    <div className="row mb-sm-2 mb-3">
                                       <div className="col-sm-3">
                                          <h5 className="f-w-500">
                                             Year Experience
                                             <span className="pull-right d-none d-sm-block">
                                                :
                                             </span>
                                          </h5>
                                       </div>
                                       <div className="col-sm-9">
                                          <span>07 Year Experiences</span>
                                       </div>
                                    </div> */}
                                            </div>
                                        </div>
                                        <div
                                            id="profile-settings"
                                            className={`tab-pane fade ${activeToggle === "setting"
                                                ? "active show"
                                                : ""
                                                }`}
                                        >
                                            <div className="pt-3">
                                                <div className="settings-form">
                                                    <h4 className="text-primary">
                                                        Account Setting
                                                    </h4>
                                                    <form
                                                        onSubmit={(e) => e.preventDefault()}
                                                    >
                                                        <div className="form-row">
                                                            <div className="form-group col-md-6">
                                                                <label>Email</label>
                                                                <input
                                                                    type="email"
                                                                    placeholder="Email"
                                                                    className="form-control"
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-6">
                                                                <label>Password</label>
                                                                <input
                                                                    type="password"
                                                                    placeholder="Password"
                                                                    className="form-control"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Address</label>
                                                            <input
                                                                type="text"
                                                                placeholder="1234 Main St"
                                                                className="form-control"
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Address 2</label>
                                                            <input
                                                                type="text"
                                                                placeholder="Apartment, studio, or floor"
                                                                className="form-control"
                                                            />
                                                        </div>
                                                        <div className="form-row">
                                                            <div className="form-group col-md-6">
                                                                <label>City</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-4">
                                                                <label>State</label>
                                                                <select
                                                                    className="form-control"
                                                                    id="inputState"
                                                                    defaultValue="option-1"
                                                                >
                                                                    <option value="option-1">
                                                                        Choose...
                                                                    </option>
                                                                    <option value="option-2">
                                                                        Option 1
                                                                    </option>
                                                                    <option value="option-3">
                                                                        Option 2
                                                                    </option>
                                                                    <option value="option-4">
                                                                        Option 3
                                                                    </option>
                                                                </select>
                                                            </div>
                                                            <div className="form-group col-md-2">
                                                                <label>Zip</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="form-group">
                                                            <div className="custom-control custom-checkbox">
                                                                <input
                                                                    type="checkbox"
                                                                    className="custom-control-input"
                                                                    id="gridCheck"
                                                                />
                                                                <label
                                                                    className="custom-control-label"
                                                                    htmlFor="gridCheck"
                                                                >
                                                                    Check me out
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <button
                                                            className="btn btn-primary"
                                                            type="submit"
                                                        >
                                                            Sign in
                                                        </button>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            id="profile-events"
                                            className={`tab-pane fade ${activeToggle === "events"
                                                ? "active show"
                                                : ""
                                                }`}
                                        >
                                            <div className="pt-3">
                                                <div className="row">
                                                    {/* <Col xl="4" lg="4" >
                                          <Card className="mb-3">
                                             <img
                                                className="card-img-top img-fluid"
                                                src={"https://media.wisemonkeys.info/blog.png"}
                                                alt="Create new"
                                             />
                                             <Card.Header>
                                                <Card.Title>Create New</Card.Title>
                                             </Card.Header>
                                             <Card.Body>
                                             </Card.Body>
                                          </Card>
                                       </Col> */}
                                                    {eventData?.map((d, i) => (

                                                        <Col xl="4" lg="4" >
                                                            <Link
                                                                to={"/events/" + d?.event_id}
                                                                className="ai-icon"
                                                            >
                                                                <Card className="mb-3">
                                                                    <img
                                                                        className="card-img-top img-fluid"
                                                                        src={"https://media.wisemonkeys.info/blog.png"}
                                                                        alt="Card cap"
                                                                    />
                                                                    <Card.Header>
                                                                        <Card.Title>{d?.event_name}</Card.Title>
                                                                    </Card.Header>
                                                                    <Card.Body>
                                                                        <Card.Text>
                                                                            {d?.status == 1 ? "Completed" : "Processing"}
                                                                        </Card.Text>
                                                                    </Card.Body>
                                                                </Card>
                                                            </Link>
                                                        </Col>

                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            id="profile-templates"
                                            className={`tab-pane fade ${activeToggle === "templates"
                                                ? "active show"
                                                : ""
                                                }`}
                                        >
                                            <div className="pt-3">
                                                <div className="row">

                                                    <Col xl="4" lg="4" >
                                                        <Link
                                                            to={"/page-template-editor/" + userId}
                                                            className="ai-icon"
                                                        >
                                                            <Card className="mb-3">
                                                                <img
                                                                    className="card-img-top img-fluid"
                                                                    src={"https://media.wisemonkeys.info/blog.png"}
                                                                    alt="Create new"
                                                                />
                                                                <Card.Header>
                                                                    <Card.Title>Create New</Card.Title>
                                                                </Card.Header>
                                                                <Card.Body>
                                                                </Card.Body>
                                                            </Card>
                                                        </Link>
                                                    </Col>

                                                    {templateData?.map((d, i) => (
                                                        <Col xl="4" lg="4" >
                                                            <Link
                                                                to={"/page-template-editor/" + userId + "/" + d?.template_id}
                                                            >
                                                                <Card className="mb-3">
                                                                    <img
                                                                        className="card-img-top img-fluid"
                                                                        src={(d?.url !== "" && d?.url !== null && d?.url !== undefined) ? d?.url : "https://media.wisemonkeys.info/blog.png"}
                                                                        alt="Card cap"
                                                                    />
                                                                    <Card.Header>
                                                                        <Card.Title>{d?.template_name}</Card.Title>
                                                                    </Card.Header>
                                                                </Card>
                                                            </Link>
                                                        </Col>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            id="profile-credits"
                                            className={`tab-pane fade ${activeToggle === "credits"
                                                ? "active show"
                                                : ""
                                                }`}
                                        >
                                            <div className="pt-4">
                                                <div className="row my-3 ml-3">
                                                    <div class="col-xl-4 col-lg-4">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Amount"
                                                            value = {credAmount} onChange={(e)=> setCredAmount(e.target.value)}
                                                        />
                                                    </div>
                                                    <div class="col-xl-4 col-lg-4">
                                                        <button
                                                            type="submit"
                                                            class="btn btn-primary mr-2"
                                                            style={{ backgroundColor: "#26abff", borderColor: "#26abff" }}
                                                            onClick={(e) => addAmount(e)}
                                                        >
                                                            Add Credits
                                                        </button>
                                                        <button
                                                            type="submit"
                                                            class="btn btn-primary ml-2"
                                                            style={{ backgroundColor: "#ff4949", borderColor: "#ff4949" }}
                                                            onClick={(e) => subtractAmount(e)}
                                                        >
                                                            Delete Credits
                                                        </button>
                                                    </div>

                                                    <div class=" col-xl-4 col-lg-4 d-flex align-items-center cred " style={{ textTransform: "capitalize" }}>
                                                        Total Balance : {creditsBalance} Credits
                                                    </div>
                                                </div>
                                                <div classname="row mb-4">
                                                    <Table responsive className="w-100">
                                                        <div id="example_wrapper" className="dataTables_wrapper">
                                                            <table id="example" className="display w-100 dataTable">
                                                                <thead>
                                                                    <tr role="row">
                                                                        {/* {data.profileTable.columns.map((d, i) => (
                                                                            <th key={i}>{d}</th>
                                                                            ))} */}
                                                                        <th>Date</th>
                                                                        <th>Action</th>
                                                                        <th>Description</th>
                                                                        <th>Transaction Amount</th>
                                                                        <th>Updated Value</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {creditsData?.map((d, i) => (
                                                                        <tr style={{color : `${d?.action===`Subtract`?`red`:`green`}`}} key={i}>
                                                                            <td><Moment format={"DD-MM-YYYY hh:mm a"} unix>{d?.created_at}</Moment></td>
                                                                            {/* <td>{d?.created_at}</td> */}
                                                                            <td>{d?.action}</td>
                                                                            <td>{d?.description}</td>
                                                                            <td>{d?.transact_value}</td>
                                                                            <td>{d?.new_value}</td>
                                                                            {/* {d.map((da, i) => (
                                      <Fragment key={i}>
                                         <td>
                                            {i === 0 ? (
                                               <img
                                                  className="rounded-circle"
                                                  width="35"
                                                  src={da}
                                                  alt=""
                                               />
                                            ) : (
                                               <Fragment>
                                                  {da}
                                                  {i === 8 && (
                                                     <div className="d-flex">
                                                        <Link
                                                           to="#"
                                                           className="btn btn-primary shadow btn-xs sharp mr-1"
                                                        >
                                                           <i className="fa fa-pencil"></i>
                                                        </Link>
                                                        <Link
                                                           to="#"
                                                           className="btn btn-danger shadow btn-xs sharp"
                                                        >
                                                           <i className="fa fa-trash"></i>
                                                        </Link>
                                                     </div>
                                                  )}
                                               </Fragment>
                                            )}
                                         </td>
                                      </Fragment>
                                   ))} */}
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                                {/* <tfoot>
                             <tr role="row">
                                {data.profileTable.columns.map((d, i) => (
                                   <th key={i}>{d}</th>
                                ))}
                             </tr>
                          </tfoot> */}
                                                            </table>
                                                        </div>
                                                    </Table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default InstituteProfile;
